/* global drupalSettings ModuloTS */

(() => {
	// VARS
	const mediaContents = document.querySelectorAll(
		'.video .media-content-video'
	);
	const medias = drupalSettings.media;

	// FUNCTION
	// check if media is allowed in cookies and render HTML content with condition
	const renderMedias = () => {
		mediaContents.forEach((el) => {
			const media = Object.values(medias).filter(
				(media) => media.entity_id === `${el.id}`
			)[0];
			const provider = media.provider;

			if (document.cookie.indexOf(`${provider}=true`) > -1) {
				el.innerHTML = media.iframe;
			} else {
				el.classList.add('not_allowed');
				el.innerHTML = `<p> ${
					provider.charAt(0).toUpperCase() + provider.slice(1)
				} est désactivé </p>
                                <button class="allow__cookie" data-allow-cookie= "${provider}">${
					ModuloTS.Allow
				}</button>`;
			}
		});
	};

	// date expiration cookie RGDP
	const expirationDate = () => {
		const days = 395; // RGPD date expiration à 13 mois
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		date.toGMTString();
		return date;
	};

	// Function to allow media cookie and render media in html
	const allowMedias = (button) => {
		const expiration = expirationDate();
		const options = 'expires=' + expiration + ';path=/;secure;';
		const media = button.getAttribute('data-allow-cookie');
		document.cookie = media + '=true;' + options;
		document.cookie = 'hasConsent=choice;' + options;
		renderMedias();
	};

	// INIT
	const init = () => {
		renderMedias();

		const allowButtons =
			document.querySelectorAll('.video [data-allow-cookie]') || null;

		if (allowButtons) {
			allowButtons.forEach((el) => {
				el.addEventListener('click', () => allowMedias(el));
			});
		}
	};

	init();
})();
